// TintiCloud — Portal do Cliente: site gerenciado, permissões e chamados. Demo.

// O cliente enxerga o SITE como serviço (sem Docker/NPM/IP/networks).
export const clientSite = {
  id: "smartfolks",
  name: "Meu Site",
  domain: "smartfolks.com.br",
  status: "online", // online | starting | restarting | stopping | offline | error
  ssl: "protected",
  sslExpires: "02/11/2026",
  uptime: "99.9%",
  lastBackup: "Hoje 03:00",
  plan: "Pro",
  // Permissões preparadas para RBAC futuro (mock)
  permissions: { canControl: true, canStart: true, canStop: true, canRestart: true },
};

// Serviços amigáveis do cliente (sem complexidade de infraestrutura)
export const clientServices = [
  { key: "wordpress", title: "WordPress Admin", subtitle: "Editar conteúdo do site", icon: "layout", action: "Administrar" },
  { key: "webmail", title: "Webmail", subtitle: "3 caixas ativas", icon: "mail", action: "Abrir Webmail" },
  { key: "backups", title: "Backups", subtitle: "Último: hoje 03:00", icon: "archive", action: "Ver Backups" },
  { key: "sftp", title: "SFTP / FTP", subtitle: "Acesso seguro a arquivos", icon: "folder", action: "Credenciais" },
  { key: "database", title: "Banco de Dados", subtitle: "Gerenciar dados do site", icon: "database", action: "Acessar" },
  { key: "domains", title: "Domínios", subtitle: "smartfolks.com.br", icon: "globe", action: "Gerenciar" },
];

// Chamados / Suporte
export const tickets = [
  {
    id: "TIC-1042", subject: "E-mail não está recebendo mensagens", category: "E-mail", service: "smartfolks.com.br",
    priority: "high", status: "in_progress", updated: "há 2 h", created: "20/09/2026 09:12", client: "Smartfolks",
    messages: [
      { from: "client", author: "Cliente Smartfolks", at: "20/09 09:12", text: "Desde ontem não recebo e-mails na caixa suporte@smartfolks.com.br." },
      { from: "agent", author: "Ana Souza · TintiCloud", at: "20/09 09:40", text: "Olá! Estamos verificando os registros MX do domínio. Retornamos em breve." },
      { from: "client", author: "Cliente Smartfolks", at: "20/09 10:05", text: "Obrigado! Fico no aguardo." },
    ],
  },
  {
    id: "TIC-1039", subject: "Quero aumentar o armazenamento", category: "Plano", service: "smartfolks.com.br",
    priority: "medium", status: "waiting_client", updated: "há 1 dia", created: "19/09/2026 15:30", client: "Smartfolks",
    messages: [
      { from: "client", author: "Cliente Smartfolks", at: "19/09 15:30", text: "Preciso de mais espaço para o site." },
      { from: "agent", author: "Bruno Lima · TintiCloud", at: "19/09 16:10", text: "Podemos migrar para o plano Business (60GB). Confirma o upgrade?" },
    ],
  },
  {
    id: "TIC-1030", subject: "Certificado SSL renovado", category: "SSL", service: "smartfolks.com.br",
    priority: "low", status: "resolved", updated: "há 5 dias", created: "15/09/2026 11:00", client: "Smartfolks",
    messages: [
      { from: "client", author: "Cliente Smartfolks", at: "15/09 11:00", text: "O cadeado apareceu como inseguro." },
      { from: "agent", author: "Ana Souza · TintiCloud", at: "15/09 11:20", text: "Certificado renovado com sucesso. Já está tudo protegido!" },
    ],
  },
];

export const ticketCategories = ["Site", "E-mail", "WordPress", "SSL", "Backup", "Plano", "Outro"];
export const ticketPriorities = [
  { value: "low", label: "Baixa" },
  { value: "medium", label: "Média" },
  { value: "high", label: "Alta" },
];
